import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { FeatureGridSection } from './components/FeatureGridSection';
import { QualitySection } from './components/QualitySection';
import { ServicesSection } from './components/ServicesSection';
import { Footer } from './components/Footer';
import { ContactCTA } from './components/ContactCTA';
import { OfferteAanvragen } from './components/OfferteAanvragen';
import { AboutUs } from './components/AboutUs';
import { Products } from './components/Products';
import { AdviesGesprek } from './components/AdviesGesprek';
import { Contact } from './components/Contact';
import { WhatsAppWidget } from './components/WhatsAppWidget';
import { InstagramFeed } from './components/InstagramFeed';
import { ScrollToTop } from './components/ScrollToTop';
import { SEO } from './components/SEO';
import { Helmet } from 'react-helmet';
export function App() {
  return <Router data-id="element-0">
      <Helmet data-id="element-1">
        <meta name="viewport" content="width=device-width, initial-scale=1" data-id="element-2" />
        <meta charSet="utf-8" data-id="element-3" />
        <link rel="sitemap" type="application/xml" href="/sitemap.xml" data-id="element-4" />
        {/* Google Analytics */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-5Z4JD9999P" data-id="element-5"></script>
        <script data-id="element-6">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-5Z4JD9999P');
          `}
        </script>
      </Helmet>
      <ScrollToTop data-id="element-7" />
      <WhatsAppWidget data-id="element-8" />
      <Routes data-id="element-9">
        <Route path="/offerte-aanvragen" element={<>
              <SEO title="Offerte Aanvragen | Veranova Klussen - Veranda's en Overkappingen" description="Vraag vrijblijvend een offerte aan voor uw veranda, overkapping of ander buitenproject. Ontvang binnen 48 uur een persoonlijke offerte op maat." canonicalUrl="/offerte-aanvragen" keywords="offerte veranda, prijs overkapping, kosten glazen schuifwand, veranda offerte aanvragen" data-id="element-11" />
              <OfferteAanvragen data-id="element-12" />
            </>} data-id="element-10" />
        <Route path="/adviesgesprek" element={<div className="flex flex-col min-h-screen w-full bg-white" data-id="element-14">
              <SEO title="Plan een Adviesgesprek | Veranova Klussen - Expert Advies" description="Plan een vrijblijvend adviesgesprek met onze veranda experts. Persoonlijk advies over materialen, mogelijkheden en kosten voor uw droomproject." canonicalUrl="/adviesgesprek" keywords="veranda advies, overkapping expert, vrijblijvend gesprek, tuinkamer specialist" data-id="element-15" />
              <Header data-id="element-16" />
              <main className="flex-grow pt-20" data-id="element-17">
                <AdviesGesprek data-id="element-18" />
              </main>
              <InstagramFeed data-id="element-19" />
              <Footer data-id="element-20" />
            </div>} data-id="element-13" />
        <Route path="/contact" element={<div className="flex flex-col min-h-screen w-full bg-white" data-id="element-22">
              <SEO title="Contact | Veranova Klussen - Neem contact met ons op" description="Neem direct contact op met Veranova Klussen voor vragen over veranda's, overkappingen, schuifwanden en meer. Wij helpen u graag verder." canonicalUrl="/contact" keywords="contact veranda specialist, overkapping contact, veranda bedrijf contact, tuinkamer aannemer" data-id="element-23" />
              <Header data-id="element-24" />
              <main className="flex-grow pt-20" data-id="element-25">
                <Contact data-id="element-26" />
              </main>
              <InstagramFeed data-id="element-27" />
              <Footer data-id="element-28" />
            </div>} data-id="element-21" />
        <Route path="/over-ons" element={<div className="flex flex-col min-h-screen w-full bg-white" data-id="element-30">
              <SEO title="Over Ons | Veranova Klussen - Vakmanschap & Expertise" description="Ontdek het verhaal achter Veranova Klussen. Meer dan 500 tevreden klanten kozen voor ons vakmanschap in veranda's, overkappingen en tuinkamers." canonicalUrl="/over-ons" keywords="veranda specialist, overkapping vakmanschap, tuinkamer expert, Nederlands bedrijf veranda's" data-id="element-31" />
              <Header data-id="element-32" />
              <main className="flex-grow pt-20" data-id="element-33">
                <AboutUs data-id="element-34" />
              </main>
              <InstagramFeed data-id="element-35" />
              <Footer data-id="element-36" />
              <ContactCTA data-id="element-37" />
            </div>} data-id="element-29" />
        <Route path="/producten" element={<div className="flex flex-col min-h-screen w-full bg-white" data-id="element-39">
              <SEO title="Producten | Veranova Klussen - Veranda's, Overkappingen & Meer" description="Ontdek ons complete assortiment veranda's, overkappingen, schuifwanden en tuinkamers. Hoogwaardige producten met 100% Nederlands vakmanschap." canonicalUrl="/producten" keywords="veranda's, glazen overkapping, polycarbonaat dak, lamellendak, schuifwanden, tuinkamer, carport" data-id="element-40" />
              <Header data-id="element-41" />
              <main className="flex-grow pt-20" data-id="element-42">
                <Products data-id="element-43" />
              </main>
              <InstagramFeed data-id="element-44" />
              <Footer data-id="element-45" />
              <ContactCTA data-id="element-46" />
            </div>} data-id="element-38" />
        <Route path="/" element={<div className="flex flex-col min-h-screen w-full bg-white" data-id="element-48">
              <SEO title="Veranova Klussen | Specialist in Veranda's en Overkappingen" description="Veranova Klussen is dé specialist in veranda's, overkappingen, tuinkamers en glazen schuifwanden. 100% Nederlands vakmanschap met meer dan 500 tevreden klanten." canonicalUrl="/" keywords="veranda, overkapping, tuinkamer, glazen schuifwand, carport, lamellendak, polycarbonaat dak" data-id="element-49" />
              <Header data-id="element-50" />
              <main className="flex-grow" data-id="element-51">
                <HeroSection data-id="element-52" />
                <FeatureGridSection data-id="element-53" />
                <ServicesSection data-id="element-54" />
                <QualitySection data-id="element-55" />
              </main>
              <InstagramFeed data-id="element-56" />
              <Footer data-id="element-57" />
              <ContactCTA data-id="element-58" />
            </div>} data-id="element-47" />
      </Routes>
    </Router>;
}